import { HelpOutlined } from '@mui/icons-material';
import { Tooltip, IconButton } from '@mui/material';
import { tss } from 'tss-react/mui';

import { env } from '@/env';

const useStyles = tss.create({
  root: {
    display: 'inline-flex',

    alignItems: 'center',
    width: '100%',
  },

  button: {
    width: '1em',
    height: '1em',

    '&:hover': {
      textDecoration: 'none',
    },
  },
});

export const VisibleToLabel = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <span>Visible to</span>
      <Tooltip title="Learn more about restricted visiblity">
        <IconButton
          className={classes.button}
          href={`${env.NEXT_PUBLIC_HELP_URL}/en/articles/9711722-how-do-i-restrict-the-visibility-of-a-folder`}
          target="_blank"
          size="large"
        >
          <HelpOutlined />
        </IconButton>
      </Tooltip>
    </div>
  );
};
